module.exports = __webpack_public_path__ + "img/left.c109ca4f.svg";